import { css } from '@emotion/react'

export const regular = css`
  img {
    width: 142px;
    height: 42px;
  }
`

export const small = css`
  img {
    width: 84px;
    height: 24px;
  }
`
